export function getNextChipFilterValues<T>(currentValues: T[], value: T | T[] | null): T[] {
  if (value === null) {
    return [];
  }

  if (Array.isArray(value)) {
    const valuesToKeep = currentValues.filter((currentValue) => !value.includes(currentValue));
    const valuesToAdd = value.filter((nextValue) => !currentValues.includes(nextValue));
    return [...valuesToKeep, ...valuesToAdd];
  }

  return currentValues.includes(value)
    ? currentValues.filter((currentValue) => currentValue !== value)
    : [...currentValues, value];
}

// Adapts the CDS multi-select SelectChip onChange to a React array-state setter.
export function makeChipFilterChange<T>(setter: (update: T[] | ((prev: T[]) => T[])) => void) {
  return (value: T | T[] | null) => {
    setter((currentValues) => getNextChipFilterValues(currentValues, value));
  };
}
